//ドロップダウンメニュー
function mediaQueriesWin(){
	var width = $(window).width();
	if(width <= 768) {//横幅が768px以下の場合 $(".has-child>a").off('click');	//has-childクラスがついたaタグのonイベントを複数登録を避ける為offにして一旦初期状態へ
		$(".has-child>a").on('click', function() {//has-childクラスがついたaタグをクリックしたら
			var parentElem =  $(this).parent();// aタグから見た親要素のliを取得し
			$(parentElem).toggleClass('active');//矢印方向を変えるためのクラス名を付与して
			$(parentElem).children('ul').stop().slideToggle(500);//liの子要素のスライドを開閉させる※数字が大きくなるほどゆっくり開く
			return false;//リンクの無効化
		});
	}else{//横幅が768px以上の場合
		$(".has-child>a").off('click');//has-childクラスがついたaタグのonイベントをoff(無効)にし
		$(".has-child").removeClass('active');//activeクラスを削除
		$('.has-child').children('ul').css("display","");//スライドトグルで動作したdisplayも無効化にする
	}
}


//ヘッダー
(function () {
  const HEADER_SELECTORS = [".header", ".spheader"];

  function updateHeader() {
    // 告知バーはページと一緒にスクロールして画面外へ消えるが、
    // ヘッダーは position:fixed のため元の位置（告知バーの下）に残り、
    // 上部に告知バーの高さぶんの隙間ができて裏の本文が透けてしまう。
    // 告知バーの「まだ画面に残っている高さ」をヘッダーの top に反映して隙間をなくす。
    const bar = document.querySelector(".announcement-bar-section");
    const barHeight = bar ? bar.offsetHeight : 0;
    const top = Math.max(0, barHeight - window.scrollY);

    HEADER_SELECTORS.forEach(function (selector) {
      const header = document.querySelector(selector);
      if (!header) return;
      header.style.top = top + "px";
      // 200px以上スクロールしたらヘッダーに「scroll-nav」クラスをつける
      header.classList.toggle("scroll-nav", window.scrollY > 200);
    });
  }

  window.addEventListener("scroll", updateHeader, { passive: true });
  window.addEventListener("resize", updateHeader);
  updateHeader();
})();

//Lineボタン（※ .button-013 が無いページでは何もしない）
window.addEventListener("scroll", function () {
  const elm = document.querySelector(".button-013");
  if (!elm) return;

  const scroll = window.pageYOffset;
  elm.style.opacity = (scroll > 500) ? "1" : "0";
});